import { render, staticRenderFns } from "./PublicadasConvocatorias.vue?vue&type=template&id=08c7338f"
import script from "./PublicadasConvocatorias.vue?vue&type=script&lang=js"
export * from "./PublicadasConvocatorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports